"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TitleBarLabel = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@fluentui/react");

var _stylingConstants = require("../styling/stylingConstants");

var _useResponsiveMode = require("../styling/useResponsiveMode");

var _TitleBarMarkers = require("./TitleBarMarkers");

var getClassNames = (0, _react2.classNamesFunction)();
/**
 * A labeled to be displayed in the center of a title bar. Use this as an
 * immediate child of a `TitleBar` and it will be placed correctly.
 */

var TitleBarLabelBase = function TitleBarLabelBase(_ref) {
  var className = _ref.className,
      responsiveVisibilityMin = _ref.responsiveVisibilityMin,
      width = _ref.width,
      vertical = _ref.vertical,
      styles = _ref.styles,
      children = _ref.children;
  var responsiveMode = (0, _useResponsiveMode.useResponsiveMode)();
  var classes = getClassNames(styles, {
    width: width,
    vertical: vertical
  });
  return !responsiveVisibilityMin || responsiveMode >= responsiveVisibilityMin ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _react2.css)('ms-TitleBar--label', className, classes.root),
    children: children
  }) : null;
};

var TitleBarLabel = (0, _react2.styled)(TitleBarLabelBase, function (_ref2) {
  var _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 'auto' : _ref2$width,
      vertical = _ref2.vertical;
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flex: vertical ? "0 1 auto" : "1 1 ".concat(width),
      paddingLeft: _stylingConstants.gridUnit * 0.5,
      paddingRight: _stylingConstants.gridUnit * 0.5,
      minWidth: 0,
      whiteSpace: 'no-wrap',
      overflow: 'visible',
      textOverflow: 'ellipsis'
    }
  };
});
exports.TitleBarLabel = TitleBarLabel;

_TitleBarMarkers.TitleBarLabelMarker.mark(TitleBarLabel);